import "./confirmedAppointment.scss";

import React, { useEffect, useState } from "react";

import Button from "../../atoms/button/button";
import { Input } from "../../../shared/comfama-ui/components/form";
import ModalGeneric from "../../atoms/modal-generic/modalGeneric";
import checkTurquesa from "../../../assets/images/check-turquesa.png";
import iconFemale from "../../../assets/icons/icon-female.png";
import iconMale from "../../../assets/icons/icon-male.png";
import { navigate } from "gatsby";
import { postAssignAppointment } from "../../../services/scheduling";

const confirmedAppointment = ({
  appointmenData,
  globalContext,
  informationService,
  psychologicalContent,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkboxCall, setCheckboxCall] = useState(false);
  const [confirmData, setConfirmData] = useState(false);
  const [checkboxVideoCall, setCheckboxVideoCall] = useState(false);
  const [informedConsent, setInformedConsent] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [formDataUser, setFormDataUser] = useState({
    code: "",
    phone: "",
    email: "",
  });
  const [nameProfessional, professional] = appointmenData.professional?.split(
    "_"
  );

  const replaceUrlVariables = (url, docNumber, docType) => {
    const urlObj = new URL(url);
    urlObj.search = urlObj.search.replace(/\$\{document\}/g, encodeURIComponent(docNumber))
                                 .replace(/\$\{documentType\}/g, encodeURIComponent(docType));
  
    let returnUrlParam = urlObj.searchParams.get('returnUrl');
    if (returnUrlParam) {
      while (returnUrlParam.includes('%')) {
        returnUrlParam = decodeURIComponent(returnUrlParam);
      }
      returnUrlParam = returnUrlParam.replace(/\$\{document\}/g, docNumber)
                                     .replace(/\$\{documentType\}/g, docType);
  
      returnUrlParam = encodeURIComponent(returnUrlParam);

      urlObj.searchParams.set('returnUrl', returnUrlParam);
    }
    return urlObj.toString();
  }

  const handleCheckboxChange = (checkbox) => {
    if (checkbox === "checkboxCall") {
      setCheckboxCall(true);
      setCheckboxVideoCall(false);
    } else if (checkbox === "checkboxVideoCall") {
      setCheckboxCall(false);
      setCheckboxVideoCall(true);
    } else if (checkbox === "informedConsent") {
      setInformedConsent(!informedConsent);
    }
  };

  useEffect(() => {
    if (globalContext) {
      const mobile =
        globalContext?.gigyaContext?.gigyaAccount?.data.mobile || "";
      const verifyingEmail =
        globalContext.gigyaContext?.gigyaAccount?.profile?.email || "";
      const maskedEmail =
        verifyingEmail.substring(0, 4) + "*".repeat(verifyingEmail.length - 4);

      setFormDataUser({
        code: "+57",
        phone: maskMobile(mobile),
        email: maskedEmail,
      });
    }
  }, [globalContext]);

  const maskMobile = (mobile) => {
    return mobile.substring(0, 4) + "*".repeat(mobile.length - 4);
  };

  const startDate = new Date(appointmenData.start_time);
  const dayWeek = startDate.toLocaleDateString("default", { weekday: "long" });
  const dayMonth = startDate.getUTCDate();

  const formatteDate = `${dayWeek} ${dayMonth} de ${startDate.toLocaleDateString(
    "default",
    { month: "long" }
  )}`;

  const cardContent = (
    <div>
      <div className={`card `}>
        <div className="top-section">
          <div className="iconUser">
            <img
              src={professional === "Psicóloga" ? iconFemale : iconMale}
              alt="Icono de usuario"
            />
          </div>
          <div className="content">
            <div className="name">
              <p>{nameProfessional}</p>
            </div>
            <div className="profession">
              <p>{professional}</p>
            </div>
            <div>
              <i className="icon iconRedAmor-icon-icon-calendar" />
              <strong>
                {" "}
                {formatteDate} | {appointmenData.time}
              </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const confirmAppointment = async () => {
    if (!isConfirmed && confirmData) {
      setIsConfirmed(true);
      const result = checkFirstFourDigitsAndLetters();
      let dataUser;
      let typeAttention = checkboxCall ? 3 : checkboxVideoCall ? 2 : 0;
      const email = globalContext.gigyaContext.gigyaAccount.profile?.email;
      const phone = globalContext.gigyaContext.gigyaAccount.data.mobile;

      dataUser =
        result.success === false && result.failedConditions.length == 0
          ? formDataUser
          : result.failedConditions.includes("email")
          ? { email: formDataUser.email, phone }
          : result.failedConditions.includes("mobile")
          ? { email, phone: formDataUser.phone }
          : { email, phone };

      //  TODO: the next const was added
      const appointmetInfo = {
        customer: {
          email: dataUser.email,
          mobilePhone: dataUser.phone,
        },
        resource: {
          id: appointmenData.professional_id,
        },
        service: {
          id: appointmenData.service_id,
          startTime: appointmenData.start_time,
          endTime: appointmenData.end_time,
        },
        place: {
          placeId: appointmenData.place_id,
        },
      };

      //  TODO: this part was changed
      try {
        const responseData = await postAssignAppointment(
          appointmetInfo,
          globalContext.userInfoContext.data?.userJwt
        );
        if (responseData.userMessage === "Creación de cita completa") {
          if (
            informationService?.price > 0 ||
            informationService?.price != undefined
          ) {
            const url = replaceUrlVariables( informationService.url, globalContext.gigyaContext.gigyaAccount.data.docNumber, globalContext.gigyaContext.gigyaAccount.data.docType);
            window.location.href = url;
          } else {
            setIsModalOpen(true);
          }
        }
      } catch (error) {
        console.error("Error al crear la cita:", error);
      }
    }
  };

  const checkFirstFourDigitsAndLetters = () => {
    const currentMobile = globalContext.gigyaContext.gigyaAccount.data.mobile;
    const currentEmail = globalContext.gigyaContext.gigyaAccount.profile?.email;

    const mobileCondition = currentMobile.startsWith(
      formDataUser.phone.substring(0, 4)
    );
    const emailCondition =
      currentEmail &&
      currentEmail.startsWith(formDataUser.email.substring(0, 4));
    const failedConditions: string[] = [];
    if (mobileCondition && emailCondition) {
      return { success: true, failedConditions };
    } else {
      if (!mobileCondition) {
        failedConditions.push("mobile");
      }
      if (!emailCondition) {
        failedConditions.push("email");
      }

      return { success: false, failedConditions };
    }
  };

  const confirmedData = () => {
    setConfirmData(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const redirect = () => {
    setIsModalOpen(false);
    navigate("/");
  };

  const isEmailValid = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <div className={`o-verification-mpc`}>
      <div className={`container`}>
        <div className="o-verification-mpc__container">
          <img src={checkTurquesa} />
          <h1> {psychologicalContent.tituloGeneral}</h1>
          <h2>Confirma tus datos de contacto</h2>
          <p className="o-verification-mpc__paragraph">
            {" "}
            Puedes modificarlos si es necesario
          </p>
        </div>
      </div>
      <div className={`container-form`}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div className="o-verification-mpc__form">
            <div className="o-verification-mpc__form__field">
              <div className="input-container">
                <Input
                  placeholder="(+57)"
                  value={formDataUser.code}
                  type="number"
                  name="code"
                  className="o-verification-mpc__form__field__input input-small"
                  onChange={(e) =>
                    setFormDataUser({ ...formDataUser, code: e.target.value })
                  }
                />
                <Input
                  placeholder="*** ***3251"
                  type="text"
                  name="text"
                  value={formDataUser.phone}
                  onChange={(e) =>
                    setFormDataUser({ ...formDataUser, phone: e.target.value })
                  }
                  className="o-verification-mpc__form__field__input"
                />
              </div>
            </div>
            <div className="o-verification-mpc__form__field">
              <div>
                <Input
                  placeholder="eob***@gmail.com"
                  type="text"
                  name="email"
                  className="o-verification-mpc__form__field__input"
                  value={formDataUser.email}
                  onChange={(e) =>
                    setFormDataUser({ ...formDataUser, email: e.target.value })
                  }
                />
                {!isEmailValid(formDataUser.email) &&
                  confirmData &&
                  !formDataUser.email.includes("*") && (
                    <p style={{ color: "red" }}>
                      El formato del correo electrónico no es válido.
                    </p>
                  )}
              </div>
            </div>
          </div>
        </form>
      </div>
      {
        <div className="o-verification-mpc-response">
          <div className="o-verification-mpc-response__button">
            <Button
              type="button"
              text="Confirmar datos"
              classname={`secondary a-button primary`}
              isDisabled={false}
              onClickAction={confirmedData}
            />
          </div>

          {/* TODO: at the moment appointment options are not going */}
          {/* <div className="o-verification-mpc-response__header">
            <p className="o-verification-mpc-response__title__paragraphInitial">
              Elige las opciones por las que prefieres atender tu cita:
            </p>
          </div>
          <div className="o-verification-mpc-response__checkbox">
            <label>
              <input
                type="checkbox"
                checked={checkboxVideoCall}
                onChange={() => handleCheckboxChange("checkboxVideoCall")}
              />{" "}
              Videollamada
            </label>
            <label>
              <input
                type="checkbox"
                checked={checkboxCall}
                onChange={() => handleCheckboxChange("checkboxCall")}
              />{" "}
              Llamada telefónica
            </label>
          </div> */}
          {/* TODO: at the moment appointment options are not going */}
          <div className="o-verification-mpc-response__check">
            <p className="o-verification-mpc-response__title__paragraphInitial">
              <label>
                <input
                  type="checkbox"
                  checked={informedConsent}
                  onChange={() => handleCheckboxChange("informedConsent")}
                />{" "}
                Leíste y aceptas el
                <a
                  href={psychologicalContent.listaImagenes[0].file.url}
                  target="_blank"
                  className="o-verification-mpc-response__title__consent"
                >
                  {" "}
                  consentimiento informado
                </a>
              </label>
            </p>
          </div>
          <a
            href={psychologicalContent.listaImagenes[2].file.url}
            target="_blank"
            className="o-verification-mpc-response__title__link"
          >
            Recomendaciones
          </a>
          <a
            href={psychologicalContent.listaImagenes[1].file.url}
            target="_blank"
            className="o-verification-mpc-response__title__link"
          >
            Políticas de servicio
          </a>
          <p className="o-verification-mpc-response__title__cost">
            Tu cita tiene un costo de{" "}
            <strong> $ {informationService?.price?.toLocaleString()}</strong>
          </p>
          {/* TODO: at the moment appointment options are not going */}
          {/* {!checkboxCall && !checkboxVideoCall && (
            <span className="o-verification-mpc-response__error-message">
              Debes seleccionar al menos una opción (videollamada o llamada
              telefónica).
            </span>
          )} */}
          {/* TODO: at the moment appointment options are not going */}
          {!informedConsent && (
            <span className="o-verification-mpc-response__error-message">
              Debes aceptar el consentimiento informado.
            </span>
          )}
          {!confirmData && (
            <span className="o-verification-mpc-response__error-message">
              Debes confirmar tus datos.
            </span>
          )}
          <div className="o-verification-mpc-response__buttons">
            <Button
              type="button"
              text="Pagar"
              onClickAction={confirmAppointment}
              classname={`secondary a-button primary`}
              isDisabled={
                !(
                  // (checkboxCall || checkboxVideoCall) && //TODO: not need it, at the moment
                  (confirmData && !isConfirmed && informedConsent)
                )
              }
            />
            <Button
              classname="a-button primary"
              type="link"
              text="Regresar"
              isDisabled={false}
              href="./"
            />
          </div>
        </div>
      }
      <ModalGeneric
        isOpen={isModalOpen}
        onClose={closeModal}
        redirect={redirect}
        title="¡Tu cita está confirmada!"
        subtitle="Has agendado una cita de atención psicológica con:"
        cardContent={cardContent}
      />
    </div>
  );
};

export default confirmedAppointment;
